// native
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// service
import { GlobalsService } from './globals.service';
import { ApiService } from './api.service';

// models
import { StylesInfo, AddCustomStyleRequestBody, StyleRequestBody } from '../../models';


@Injectable({
  providedIn: 'root'
})
export class CustomStyleService {

  isCustomStyleDialogOpen: boolean = false;

  constructor(
    private globalsService: GlobalsService,
    private apiService: ApiService
  ) { }

  addCustomStyle(styleBody: string, styleTitle: string): Observable<StylesInfo> {
    const url = `${this.globalsService.appConfig.environment.baseUrls.services}/citation_styles/add_user_custom`;

    const body: AddCustomStyleRequestBody = {
      title: styleTitle,
      body: styleBody
    };

    return this.apiService.post(url, body);
  }

  removeCustomStyle(styleId: string): Observable<StylesInfo> {
    const url = `${this.globalsService.appConfig.environment.baseUrls.services}/citation_styles/remove_user_custom`;

    const body: StyleRequestBody = { style_id: styleId };

    return this.apiService.post(url, body);
  }
}
